export default __webpack_public_path__ + "static/media/modelingImg2.d586809b.jpg";